export const lastTransactions = (state) => state.lastTransactions;
